<template>
  <div class="lp-check-bool-container unselect">
    <div class="check-box"
      :class="{ 'checked' : (isChecked && !disabled),
                'not-checked' : (!isChecked && !disabled),
                'disabled' : disabled }"
         :style="checkStyle"
         style="display:flex"
         @click.stop.prevent="clickCheck">
      <svg v-if="isChecked && !disabled"
        width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="1.28" y1="3.26343" x2="5.70658" y2="7.25178" stroke="white"/>
        <line x1="5.00221" y1="7.28671" x2="10.6845" y2="1.04037" stroke="white"/>
      </svg>
      <!--<i v-if="isChecked && !disabled"
         :style="iconStyle"
         class="material-icons"
         @click.stop.prevent="clickCheck">check</i>-->
    </div>
    <div :style="labelStyle"
         @click.stop.prevent="clickCheck">{{ label }}</div>
  </div>
</template>

<script>
  export default {
    props: {
      checkedVal: {
        type: Boolean
      },
      label: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      checkBoxStyle: {
        type: Object,
        default: () => {
          return {
            width: '16px',
            height: '16px'
          }
        }
      },
      iconStyle: {
        type: Object,
        default: () => {
          return {
            color: '#fff',
            fontSize: '0.9rem',
            fontWeight: 'bold',
            position: 'absolute',
            left: '0px',
            top: '0px'
          }
        }
      },
      labelStyle: {
        type: Object,
        default: () => {
          return {
            fontSize: '13px',
            lineHeight: '18.82px',
            color: '#787878'
          }
        }
      }
    },
    created() {
      this.isChecked = this.checkedVal;
      /*if(this.disabled) {
        this.isChecked = false;
      }*/
    },
    data() {
      return {
        isChecked: false
      }
    },
    computed: {
      checkStyle() {
        let style = {}
        style = this.checkBoxStyle;
        if(this.label) {
          style.marginRight = 8;
        }
        else style.marginRight = 0;

        return style
      }
    },
    methods: {
      clickCheck() {
        if(this.disabled) return;

        if ( this.isChecked === false ) {
          this.isChecked = true;
        }
        else if ( this.isChecked === true ) {
          this.isChecked = false;
        }
        this.$emit('update:checkedVal', this.isChecked);
        this.$emit('onCheck', this.isChecked);
        this.$emit('dataCheck', {id:this.label, value:this.isChecked});
      }
    },
    watch: {
      disabled(n) {
        if(n) {
          this.isChecked = false;
          this.$emit('update:checkedVal', this.isChecked);
          this.$emit('onCheck', this.isChecked);
          this.$emit('dataCheck', {id:this.label, value:this.isChecked});
        }
      },
      checkedVal(n) {
        this.isChecked = n;
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_variable'
  .lp-check-bool-container
    display flex
    align-items center
    flex-wrap wrap
    cursor pointer

  .check-box
    position relative
    width 18px
    height 18px
    border 1px solid #cccccc
    border-radius 2px
    margin-right 8px
    justify-content center
    display flex
    padding 2px 0

  .checked
    background-color $primary

  .disabled
    background-color #efefef
    border 2px solid #dfdfdf

  .not-checked
    background-color #fff

  .checked-icon
    color #fff
    font-size 0.9rem
    font-weight bold
    position absolute
    left 0px
    top 0px

  /*.lp-check-bool-label*/
    // display flex

</style>
